module.exports = "<h2 id=\"component-description\">Component Description</h2>\n<p>A PageContentHeader wraps the page content header, used inside the PageContent component.</p>\n<h2 id=\"example-usage\">Example Usage</h2>\n<pre><code>&lt;PageContentHeader&gt;\n    &lt;H1&gt;Page title&lt;/H1&gt;\n    &lt;p&gt;Subtitle&lt;/p&gt;\n&lt;/PageContentHeader&gt;\n</code></pre>";


//////////////////
// WEBPACK FOOTER
// ./node_modules/html-loader!./node_modules/markdown-loader!./src/PageContentHeader/README.md
// module id = 372
// module chunks = 0